export const Divider = {
  baseStyle: {
    opacity: 1,
    borderColor: "grey.darker",
  },
}
